export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "nl-NL": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sessie beëindigd"])},
        "changed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deze sessie is beëindigd omdat u op een ander tabblad bent ingelogd als een andere gebruiker."])},
        "loginLink": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klik hier om door te gaan"])}
      },
      "nl-BE": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sessie beëindigd"])},
        "changed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deze sessie is beëindigd omdat u op een ander tabblad bent ingelogd als een andere gebruiker."])},
        "loginLink": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klik hier om door te gaan"])}
      },
      "fr-BE": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Séance terminée"])},
        "changed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cette session est terminée car vous êtes connecté en tant qu'utilisateur différent sur un autre onglet."])},
        "loginLink": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Clique ici pour continuer"])}
      },
      "fr-FR": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Séance terminée"])},
        "changed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cette session est terminée car vous êtes connecté en tant qu'utilisateur différent sur un autre onglet."])},
        "loginLink": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Clique ici pour continuer"])}
      },
      "de-DE": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sitzung beendet"])},
        "changed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Diese Sitzung wurde beendet, weil Sie in einem anderen Tabellenblatt als ein anderer Benutzer angemeldet sind."])},
        "loginLink": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zum Fortfahren hier klicken"])}
      },
      "en-GB": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Session ended"])},
        "changed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["This session has ended because you are logged in on a different tab as a different user."])},
        "loginLink": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Click here to continue"])}
      },
      "da-DK": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sessionen er slut"])},
        "changed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Denne session er afsluttet, fordi du er logget ind på en anden fane som en anden bruger."])},
        "loginLink": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klik her for at fortsætte"])}
      }
    }
  })
}